import { render } from "./ProductDetailPage.vue?vue&type=template&id=c9d49824&scoped=true&ts=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPage.vue?vue&type=script&lang=ts"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=c9d49824&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d49824"]])

export default __exports__